export default __webpack_public_path__ + "static/docs@2x-b86ba156a3278a0f4ce433e28b3f328a.png";